import { useState, useCallback, useEffect, useRef } from 'react';
import { Container, Content, LoadSpin } from './styled';
import { PresentationImage } from '../../../../components';
import VisibilitySensor from 'react-visibility-sensor';
import { Footer } from '../../components';
import { getImage } from '../../../../service/serviceChat/chatService';
import { MdOutlineDownloading } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import { BsImageAlt } from 'react-icons/bs';
import { saveAs } from 'file-saver';
import moment from 'moment';

export function Image(props) {


    const { message, className } = props;

    const refImage = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [url, setUrl] = useState('');
    const [automaticLoading, setAutomaticLoading] = useState(true);
    const [isRendered, setIsRendered] = useState(false);
    const [maxWidth, setMaxWidth] = useState(0);
    const [presentationIsOpen, setPresentationIsOpen] = useState(false);

    useEffect(() => {
        if (refImage.current === null) return
        setMaxWidth(refImage.current.width)
    }, [isRendered])
    const searchUrl = useCallback(async (message) => {
        setIsLoading(true);
        const image = await getImage(message?.id_image);
        setUrl(image?.url);
        setIsLoading(false);
        setAutomaticLoading(false);
        return
    }, []);
    const onSearchUrl = (isVisible) => {
        if (!isVisible || url) return;
        searchUrl(message);
    };
    function handleDownload() {
        saveAs(url, `webChat4u - ${moment(new Date()).format('DD-MM-yyyy HH:mm')}`)
    };
    const formatTextWithLinks = (text) => {
        const parts = text.split(/(https?:\/\/\S+)/g);
        return parts.map((part, index) => {
            if (part.match(/https?:\/\/\S+/)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#0d8ae7' }}
                    >
                        {part}
                    </a>
                );
            }

            return part.replace(/\*/g, ' ');
        });
    };

    return (

        <Container
            className={className}
            isUserSystem={message?.user_system ? true : false}
            maxWidth={maxWidth > 0 ? maxWidth : false}
        >
            {automaticLoading
                ? <VisibilitySensor
                    onChange={
                        (isVisible) => { onSearchUrl(isVisible) }
                    }
                >
                    <div className='skeleton--box'>
                        <span className='skeleton'></span>
                        <BsImageAlt className='icon--' />
                    </div>
                </VisibilitySensor>
                : <Content
                    isRenderedImage={isRendered}
                    maxWidth={(maxWidth > 0) ? maxWidth : false}
                >
                    {!isRendered
                        ? (<>
                            <div className='loading__'>
                                <span className='refresh__'>
                                    {!url &&
                                        <>
                                            {!isLoading
                                                ? <MdOutlineDownloading
                                                    onClick={
                                                        () => searchUrl(message)
                                                    }
                                                />
                                                : <LoadSpin />
                                            }
                                        </>
                                    }
                                </span>
                            </div>
                        </>)
                        : (<span className='actions__'>
                            <FiDownload
                                className='icon--'
                                onClick={() => handleDownload()}
                            />
                        </span>)
                    }
                    <img
                        ref={refImage}
                        src={url}
                        alt={'webChat4u'}
                        onLoad={() => {
                            setIsRendered(true);
                        }}
                        onClick={() => setPresentationIsOpen(true)}
                    />
                </Content>
            }
            {message?.body &&
                <p>
                    {formatTextWithLinks(message?.body)}
                </p>
            }
            <div className={`${(!message?.body) ? 'foB--' : 'fo--'}`}>
                <Footer message={message} />
            </div>
            {presentationIsOpen &&
                (<PresentationImage
                    src={url}
                    onClose={() => { setPresentationIsOpen(false) }}
                />)
            }
        </Container>
    )
}